import { render, staticRenderFns } from "./TypesMailSelector.vue?vue&type=template&id=44bf8832"
import script from "./TypesMailSelector.vue?vue&type=script&lang=js"
export * from "./TypesMailSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports